// Dishide V1.X.METRO
// Created: 10/2016
// Required : Revealizr JS
// https://git.tink.ca/projects/TINK/repos/front-end/browse/librairies/tink/javascript/dishide
;(function(factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof exports !== 'undefined') {
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery);
    }
}(function($) {
    'use strict';
	function debounce(func, wait, immediate) {
		var timeout;
		return function() {
			var context = this, args = arguments;
			var later = function() {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	}

	var dishideGlobalVar = {
		instance_index : 0
	};

    const Dishide = (function() {

        function Dishide(element, settings) {

            var _ = this;
			
			_.defaults = $.extend({
				eventOnClose : null,
                eventOnInit : null,
                eventOnShow : null,
                focusOnFirstElement : false, // Boolean
                initialFocusIndex : 0
			}, settings );

            const $app = $(element); // app is where the data-module="dishide" is declared

            _.initials = {
                $app : $app,
                app_instance_index : null,
                app_type : ( $app.data('tabs-type') !== undefined )? $app.data('tabs-type') : null,
                instance_container : null, // container that wraps the module
                focus_on_first_element : $app.attr('data-focus-on-first-element') || _.defaults.focusOnFirstElement,
                only_device : ($app.data('only-device') !== undefined) ? $app.data('only-device') : null,
                only_breakpoint : ($app.data('only-breakpoint') !== undefined) ? $app.data('only-breakpoint') : null,
                except_breakpoint : ($app.data('except-breakpoint') !== undefined) ? $app.data('except-breakpoint') : null,
                mode : ( $app.data('mode') !== undefined ) ? $app.data('mode') : null,
                $group_targets : ( $app.data( 'display-bygroup' ) !== undefined )? return_group() : null,
                trigger_wrapper : $app,
                first_load : $app.data('firstLoad') !== true,
                trigger : $app,
                tab_single : true,
                target_self : false,
                class_active : ( $app.data('class-active' ) !== undefined) ? $app.data('class-active') : 'is_active',
                module_class_active : null,
                overlay_class_active : $app.data('dishide-overlay') || null,
                $tab_active : null,
                $tab_previously_active : null,
                $follower : null,
                debounce_delay : 200,
                autofocus : true,
                focus_initial_element : null,
                items_focusable_nb : 0,
                mode_lightbox : false,
                mode_menu : false,
                mode_menu_slide : false,
                mode_overlay : false,
                tabs_enabled : false,
                has_follower : ( $app.data('has') === 'follower' ),
                target_previous : null,
                target_previous_index : 0,
                group_active_state : false // Determine if one of the group element is active
            };


            $.extend(_,  _.defaults, _.initials, dishideGlobalVar);

            if (_.$app.closest('[data-is="container-tabs"]').length) {
                _.instance_container = _.$app.closest('[data-is="container-tabs"]');
            }

            var return_group = function(){
                if (  _.instance_container !== null ) {
                    return _.instance_container.find( $( _.$app.data( 'display-bygroup' ) ) );
                } else {
                    return $( _.$app.data( 'display-bygroup' ) );
                }
            };

            if( _.$app.find('[data-is="tabs"]').length > 0 && _.app_type === null ) {
                _.trigger_wrapper = _.$app.find('[data-is="tabs"]');
            } else if( _.$app.find(`[data-is="tabs"][data-tabs-type="${_.app_type}"]`).length > 0 ) {
                _.trigger_wrapper = _.$app.find(`[data-is="tabs"][data-tabs-type="${_.app_type}"]`);
            }

            if (_.mode !== null) {
                if ( _.mode.match(/overlay/g) ) {
                    _.mode_overlay = true;
                }
                if ( _.mode.match(/lightbox/g) ) {
                    _.mode_lightbox = true;
                    _.mode_overlay = true;
                }
                if( _.mode.match(/menu/g) ) {
                    _.mode_menu = true;
                }
                if ( _.mode.match(/menu-slide/g) ) {
                    _.mode_menu_slide = true;
                }
            }

            // If true, it means there's only one _.trigger.
            // The plugin is probably use as a expand / collapse
            if ( _.trigger_wrapper.find('[data-is="tab"]').length ) {
                if (_.app_type !== null) {
                    // If true, there's a "tabception".
                    // Tab-type is to avoid conflict between tabs inside other tabs
                    _.trigger = _.trigger_wrapper.find('[data-is="tab"][data-tab-type="' + _.app_type + '"]');
                } else {
                    _.trigger = _.trigger_wrapper.find('[data-is="tab"]');
                }

                _.tab_single = false;
            } else if ( _.$app.attr('data-display-tab') != undefined) {
                if ( _.$app.hasClass( _.$app.attr('data-display-tab').substring(1) ) || _.$app.attr('id') === _.$app.attr('data-display-tab').substring(1) ) {
                    _.target_self = true;
                }
            }
			
			if ( ( (_.only_breakpoint !== null) || (_.only_device !== null && _.only_device !== '') || (_.except_breakpoint !== null) ) && _.$app.data('dishide-is_initialized') !== true ) {
				$(window).on(Revealizr.resizeORorientation, debounce(function(){
					_.init_destroy();
				}, 200));
				_.init_destroy();
			} else {
				_.init();
			}

        }

        return Dishide;
    }());

    Dishide.prototype.init = function(){
        // initialize the tabs

        var _ = this;
        _.$app.data('dishide-is_initialized', true);
        _.tabs_enabled = true;
        _.app_instance_index = dishideGlobalVar.instance_index++;

        // If the user open the page with ?td-display=tabID in url, we set that tab to active.
        var url = window.location.href;
        var url_param = (url.split('?')[1] !== undefined && url.split('?')[1].split('dishide-open') !== undefined); // replace all the URL code by URL.searchParams when IE11 is no longer supported
        var url_id = (url.split('#')[1] !== undefined && url_param === true) ? url.split('#')[1] : '';

        if (url_id.split('?')[1] !== undefined) {
            url_id = url_id.split('?')[0]
        }

        if (url_id.split('&')[1] !== undefined) {
            url_id = url_id.split('&')[0]
        }

        // A URL parameter contains dishide-open=IDOfthe_.trigger
        if (_.$app.attr('data-display-tab') === url_id || _.$app.find('[data-display-tab="#' + url_id + '"]').length >  0) {
            _.$tab_active = $('[data-display-tab="#' + url_id + '"]');
        }
        // Dishide instance is a modal or expand/collapse AND has a class "is_active" or _.open is true
        else if( ( _.target_self && _.$app.hasClass( _.class_active ) ) || ( _.tab_single && _.$app.hasClass( _.class_active ) ) ) {
            _.$tab_active = _.$app;
        }
        // Multiple tabs, but the targets are not wrapped inside the same HTML tag as the _.triggers.
        else if( _.app_type !== null ) {
            _.$tab_active = _.trigger_wrapper.find(`[data-is="tab"][data-tab-type="${_.app_type}"].${_.class_active}` )
        }
        else {
            // Default behavior. A wrapper containing multiple tabs.
            _.$tab_active = _.trigger_wrapper.find('[data-is="tab"].' + _.class_active );
        }

        _.tab_active();
        // binding click on every _.trigger
        if( !_.target_self ) {
            _.trigger.on('click.dishide', debounce(function (e) {
                var is_active = $(this).hasClass(_.class_active),
                    is_menu = $(this).attr('role') === 'menu';

                // If the tab is also a link: First click = button, second click = link
                if ($(this).attr('href') !== undefined && is_active === false) {
                    e.preventDefault();
                }

                if ( ( (!Revealizr.swiping && _.tabs_enabled === true) || (is_menu && e.which === 40 && _.tabs_enabled === true) ) && _.$app.data( 'dishide-is_animating' ) !== true ) {
                    _.$tab_active = $(this);
                    _.tab_active();
                }
            }, _.debounce_delay, true));

            // Keyboard click
            _.trigger.on('keyup.dishide', debounce(function (e) {
                if (e.which === 40 && _.tabs_enabled === true) {
                    _.$tab_active = $(this);
                    _.tab_active();
                }
            }, _.debounce_delay, true));
        }

        if (_.first_load === true) {
            _.first_load = false;
            if( typeof _.eventOnInit === 'function' ) {
                _.eventOnInit(_.$tab_active);
            }
        }
    };

    Dishide.prototype.tab_active = function(indexStart=0){
        const _ = this;
        let trigger_array = [];

        if(!_.first_load) {
            _.trigger.each(function(index){
                if( $(this).hasClass( _.class_active ) ) {
                    _.$tab_previously_active = $(this);
                }
            });
        }

        // At first load, loop through each trigger to add classes used by dishide
        if(_.first_load) {
            _.trigger.each(function(index){
                trigger_array.push( $(this) );
                if( _.$group_targets !== null ) {
                    // Binding the trigger with its target on first load if it's a group.
                    $(this).data('display-tab', _.$group_targets.eq( index ))
                }
            });
        } else if( _.$tab_active === null ) {
            // if the current tab is null, it means that the user is closing the current instance.
            trigger_array = [_.$tab_previously_active];
        } else if( _.$tab_previously_active === null ||  ( _.$tab_previously_active !== null && _.$tab_previously_active.is(_.$tab_active) ) ) {
            trigger_array = [_.$tab_active];
        } else if( _.$tab_previously_active !== null && !_.$tab_previously_active.is(_.$tab_active) ) {
            trigger_array = [_.$tab_previously_active, _.$tab_active];
        }

        let i;
        // Open / close each tab
        for( i=indexStart; i < trigger_array.length; i++ ) {
            var $trigger_current = trigger_array[i],
                $trigger_current_display;

            if( _.$app.data( 'dishide-is_animating' ) === true ) {
                _.target_previous.on( 'animationend', function(){
                    _.tab_active(_.target_previous_index+1);
                });
                return;
            }

            // Enable / disable the toggle
            var toggle = ( $trigger_current.data('toggle') !== undefined)? $trigger_current.data('toggle') : false;

            var was_active = false;

            if ( $trigger_current.hasClass( _.class_active ) && !_.first_load ) {
                was_active = true;
            }

            $trigger_current_display = ($trigger_current.data('display-tab') !== undefined) ? $trigger_current.data('display-tab') : null;

            if ( $trigger_current_display !== null ) {
                var target;
                const regexInstanceNameChar = /#|\./g;
                const regexInstanceNameSpace = / /g;

                // If the target is a group
                if( _.$group_targets !== null ) {
                    target = ( _.instance_container !== null ) ? _.instance_container.find($trigger_current_display) : $trigger_current_display;

                    // Will be added on the HTML and Modal Overlay
                    _.module_class_active = `dishide-instance-${_.$app.data( 'display-bygroup' ).replace( regexInstanceNameChar, '' ).replace( regexInstanceNameSpace, '-' )}-${_.class_active}`;
                }
                // If the target is a specific tab
                else {
                    if( _.instance_container !== null ) {
                        target = $(_.instance_container.find($trigger_current_display))
                    } else if( _.target_self ) {
                        target = _.$app;
                    } else {
                        target = $($trigger_current_display);
                    }

                    _.target_previous = target;
                    _.target_previous_index = i;

                    // Will be added on the HTML and Modal Overlay
                    _.module_class_active = `dishide-instance-${$trigger_current_display.replace( regexInstanceNameChar, '' ).replace( regexInstanceNameSpace, '-' )}-${_.class_active}`;

                }
                var animation_open = $trigger_current.attr('data-animation-open'),
                    animation_close = $trigger_current.attr('data-animation-close'),
                    is_active = $trigger_current.is( _.$tab_active );

                if( _.first_load === true ){
                    target.addClass('dishide-is_initialized');
                    $trigger_current.addClass('dishide-trigger-is_initialized');

                    // Add a class on the target if a special mode is enabled
                    if( _.mode !== null ) {
                        target.addClass(`dishide-is_${_.mode}`);
                    }

                    if( _.mode_lightbox ) {
                        if( target.attr( 'role' ) === undefined ) {
                            target.attr( 'role', 'dialog' );
                        } else {
                            console.warn( `Dishide warning : Dishide is trying to add a role dialog on ${target}, but a role already exist` );
                        }
                    }
                }

                if( is_active && was_active && !toggle ){
                    // Do nothing...
                }  else if ( (is_active && (!was_active && toggle) ) || (is_active && !was_active && !toggle ) ){
                    _.display($trigger_current, target, animation_open, animation_close, _.module_class_active);
                } else {
                    _.hide($trigger_current, target, animation_open, animation_close, _.module_class_active);
                }
                if( i === trigger_array.length - 1 ) {
                    _.$tab_previously_active = _.$tab_active;
                }
            }
        }

        _.is_one_active_item();

        if (_.has_follower === true) {
            _.follower();
        }
    };

    // display the target with an animation or not
    Dishide.prototype.display = function($trigger_current, target, animation_open, animation_close, module_class_active) {
        const _ = this;

        $trigger_current.addClass( _.class_active );

        // If the instance is opened by JS, it means there's no trigger in the DOM. Therefore, we need to assign the last focused element to dishide. When the instance closes the focus will be set on this element.
        if( _.target_self === true ) {
            _.focus_initial_element = document.activeElement;
        }

        // Add an overlay when _.mode_lightbox or _.mode_overlay
        if( _.mode_overlay ) {
            if( $( `.dishide-overlay.${_.overlay_class_active}` ).length === 0 ) {
                $('body').append( `<span class="dishide-overlay ${module_class_active}" />` );
                $('html').addClass( `dishide-overlay-is_active` );
            } else {
                $( `.dishide-overlay.${_.overlay_class_active}` ).removeClass( _.overlay_class_active ).addClass( module_class_active );
            }

            _.overlay_class_active = module_class_active;
            _.$app.data('dishide-overlay', _.overlay_class_active);

            // Overlay close action
            $( `.dishide-overlay.${_.overlay_class_active}` ).off();
            $( `.dishide-overlay.${_.overlay_class_active}` ).on( `click.${_.overlay_class_active} touchend.${_.overlay_class_active}`, debounce(function(){
                _.$tab_active = null;
                _.tab_active();
            }, _.debounce_delay));
        }

        var animate = true;
        if ($trigger_current.attr('data-animate') !== undefined) {
            try {
                animate = eval($trigger_current.attr('data-animate'));
            } catch(error) {
                console.warn( 'Animation verify', error );
            }
        }

        if (animate && $trigger_current.attr('data-animation-open') !== undefined && _.first_load === false && !$('html.ie').length) {
            _.$app.data( 'dishide-is_animating', true );

            target.addClass(animation_open);
            if ( _.mode_menu_slide ) {
                $trigger_current.closest('[data-is="slide"]').addClass(animation_open);
            }

            target.on('animationend.dishide' + _.app_instance_index, function () {
                target.off('animationend.dishide' + _.app_instance_index);
                target.addClass('dishide-target--active').removeClass(animation_open);

                display_end();

                if ( _.mode_menu_slide ) {
                    $trigger_current.closest('[data-is="slide"]').removeClass(animation_open);
                }
            });
            target.removeClass('dishide-target--inactive');

            // if lightbox _.mode is on, we trapped the focus inside of it.
            if (_.mode_lightbox === true) {
                _.lightbox_loop(target);
            }
        } else {
            target.removeClass('dishide-target--inactive').addClass('dishide-target--active');

            display_end();

            // if lightbox _.mode is on, we trapped the focus inside of it.
            if (_.mode_lightbox === true) {
                _.lightbox_loop(target);
            }
        }

        function display_end() {
            // Accessibility: We set aria-expanded at true to tell screen reader that tab is now displayed.
            $trigger_current.attr('aria-expanded', true);

            // HTML CLASS to alter the visual of something unrelated to the tab when it's opened.
            if( _.$group_targets !== null ) {
                _.group_active();
            }

            // _.Mode Exceptions
            if ( _.mode_menu && _.group_active_state === true ) {
                // _.Mode menu exceptions

                // Close the element when the user click or tab outside
                jQuery(document).on('click.dishide-' + _.app_instance_index + ' keyup.' + _.app_instance_index + ' touchend.' + _.app_instance_index, function(event) {
                    if( $(event.target).closest( $trigger_current ).length < 1 && $(event.target).closest( target ).length < 1 ) {
                        // We :
                        // - Hide the active element
                        // - Remove the document event listeners
                        // - Update the state of the group active which is false
                        _.hide($trigger_current, target, animation_open, animation_close, module_class_active);
                        jQuery(document).off('click.dishide-' + _.app_instance_index + ' keyup.' + _.app_instance_index + ' touchend.' + _.app_instance_index);
                        _.group_active();
                    }
                });
            }

            if ( _.$group_targets !== null && _.group_active_state === true ) {
                $('html').addClass(module_class_active);
            } else if( _.$group_targets === null ) {
                $('html').addClass(module_class_active);
            }

            // If user press ESCAPE while on the trigger, we close the current element
            $trigger_current.on(`keydown.dishide-target-esc${_.app_instance_index}`, debounce(function (event) {
                if ( event.which == 27 && _.$app.data( 'dishide-is_animating' ) !== true ) {
                    _.$tab_active = null;
                    _.tab_active();
                }
            }, 200));

            // If user press ESCAPE while inside he target, we close the current element
            target.on(`keydown.dishide-target-esc${_.app_instance_index}`, debounce(function (event) {
                if ( event.which == 27 && _.$app.data( 'dishide-is_animating' ) !== true && _.target_self === false ) {
                    _.$tab_active = null;
                    _.tab_active();
                }
            }, 200));

            if( _.mode_menu_slide ) {
                $trigger_current.closest('[data-is="slide"]').removeClass('dishide-target--active').addClass('dishide-target--inactive');
                focusable_elements(target).first().focus();
            }

            if( _.app_type === null && _.instance_container !== null ) {
                const btn_close = _.instance_container.find('[data-tab-close]');

                btn_close.off('click.dishide-close' + _.app_instance_index);
                btn_close.on('click.dishide-close' + _.app_instance_index, debounce(function (event) {

                    closeAction( $(this) );
                    btn_close.off('click.dishide-close' + _.app_instance_index);

                }, _.debounce_delay));

            } else {
                $(document).off('click.dishide-close' + _.app_instance_index);
				// Watch for any possible closing CTA, including the ones added by AJAX.
                $(document).on('click.dishide-close' + _.app_instance_index, '[data-tab-close][data-tabs-type="' + _.app_type + '"]', debounce(function (event) {

                    closeAction( $(this) );
                    $(document).off('click.dishide-close' + _.app_instance_index);

                }, _.debounce_delay));
            }

            function closeAction(cta) {
                // autofocus is an option on the close CTA to allow different behaviors on each CTA
                if( cta.attr('data-autofocus') === 'false' ){
                    _.autofocus = false;
                }

                _.$tab_active = null;
                _.tab_active();


            }
            _.$app.data( 'dishide-is_animating', false );

            // Generic event onShow called on every trigger
            if( typeof _.eventOnShow === 'function' ){
                _.eventOnShow($trigger_current, target);
            }

            if ($trigger_current.attr('data-mobile-fixed-scroll') !== undefined) {
                try {
                    // Note: Eval is executed even if used in a conditional statement
                    if (eval($trigger_current.attr('data-mobile-fixed-scroll'))) {
                        var $body = $('body');
                        $body.attr('data-position-scroll', $(window).scrollTop());
                        $body.addClass('modal--mobile-fixed-scroll');
                    }
                } catch (error) {
                    console.warn('Verify mobile fixed scroll:', error);
                }
            }

            // Event onShow called on specific trigger
            if ($trigger_current.data('event-onshow') !== undefined) {
                try {
                    // Note: Eval is executed even if used in a conditional statement
                   eval($trigger_current.data('event-onshow'));
                } catch (error) {
                    console.warn('Dishide event onShow:', error);
                }
            }

            // Event focus called on specific trigger
            if ($trigger_current.data('event-focus') !== undefined) {
                try {
                    // Note: Eval is executed even if used in a conditional statement
                    eval($trigger_current.data('event-focus'));
                } catch (error) {
                    console.warn('Dishide event focus:', error);
                }
            } else {
                const initial_focus_index = ( $trigger_current.attr('data-initial-focus-index') !== undefined ) ? $trigger_current.attr('data-initial-focus-index') : _.initialFocusIndex;

                if( _.mode_lightbox === true || JSON.parse(_.focus_on_first_element) === true ) {
                    _.setFocusFirstItem(target, initial_focus_index);
                }
            }
        }
    };

    // display the target with an animation or not
    Dishide.prototype.hide = function($trigger_current, target, animation_open, animation_close, module_class_active) {
		const _ = this;
        if( $trigger_current.hasClass( _.class_active ) || _.first_load ) {

            var $body = $('body');
            if ($body.hasClass('modal--mobile-fixed-scroll') && $trigger_current.attr('data-mobile-fixed-scroll') !== undefined) {
                try {
                    // Note: Eval is executed even if used in a conditional statement
                    if (eval( $trigger_current.attr('data-mobile-fixed-scroll'))) {
                        $body.removeClass('modal--mobile-fixed-scroll');
                        $(window).scrollTop($body.attr('data-position-scroll'));
                    }
                } catch (error) {
                    console.warn('Verify mobile fixed scroll:', error);
                }
            }

            var target_is_active = target.hasClass('dishide-target--active');

            if( _.mode_menu_slide && _.first_load === false ) {
                _.$app.closest('[data-is="slide"]').removeClass('dishide-target--inactive').addClass('dishide-target--active ' + animation_close);
            }

            // If an animation is set, we wait until it's done to continue
            var animate = true;
            if ($trigger_current.attr('data-animate') !== undefined) {
                try {
                    animate = eval($trigger_current.attr('data-animate'));
                } catch(error) {
                    console.warn( 'Animation verify', error );
                }
            }
            if (animate && $trigger_current.attr('data-animation-close') !== undefined && _.first_load === false && target_is_active) {
                _.$app.data( 'dishide-is_animating', true );
                target.removeClass(animation_open).addClass(animation_close);

                target.on('animationend.dishide' + _.app_instance_index, function () {
                    target.removeClass('dishide-target--active')
                        .addClass('dishide-target--inactive')
                        .removeClass(animation_close)
                        .off('animationend.dishide' + _.app_instance_index);
                    if ( _.mode_menu_slide ) {
                        _.$app.closest('[data-is="slide"]').removeClass( animation_close );
                        focusable_elements( _.$app.closest('[data-is="slide"]') ).first().focus();
                    }

                    _.$app.data( 'dishide-is_animating', false );

                    event_on_close();
                    target.off(`keyup.dishide-${_.app_instance_index}`);
                    $trigger_current.off(`keydown.dishide-target-esc${_.app_instance_index}`);
                    target.off(`keydown.dishide-target-esc${_.app_instance_index}`);
                });
            } else {
                target.removeClass('dishide-target--active').addClass('dishide-target--inactive');

                event_on_close();
                target.off(`keyup.dishide-${_.app_instance_index}`);
                $trigger_current.off(`keydown.dishide-target-esc${_.app_instance_index}`);
                target.off(`keydown.dishide-target-esc${_.app_instance_index}`);
            }

            // Accessibility: We set aria-expanded at true to tell screen reader that tab is now displayed.
            $trigger_current.attr('aria-expanded', false);
            $trigger_current.removeClass(_.class_active);

            if( _.$group_targets !== null ) {
                _.group_active();
            }

            if ( _.$group_targets !== null && group_active_state === false ) {
                $('html').removeClass(module_class_active);
            } else if( _.$group_targets === null ) {
                $('html').removeClass(module_class_active);
            }

            focus_initial_trigger();
        }

        function focus_initial_trigger() {
            if (_.first_load === false) {

                if( _.autofocus === true ) {
                    if( _.target_self === false ) {
                        $trigger_current.focus();
                    } else {
                        _.focus_initial_element.focus();
                    }
                }

                if( _.mode_lightbox === true ) {
                    target.siblings().each(function () {
                        var $object = $(this);

                        if ($object.attr('aria-was') == undefined) {
                            $object.removeAttr('aria-hidden');
                        } else {
                            $object.attr('aria-hidden', $object.attr('aria-was'));
                            $object.removeAttr('data-aria-was');
                        }

                    });
                }

                // Always reset to true because the data-tab-close may override this setting once clicked
                _.autofocus = true;
            }
        }

        function event_on_close() {
			if( _.first_load !== true ) {
				// Generic event onClose called on every trigger
				if( typeof _.eventOnClose === 'function' ){
					_.eventOnClose($trigger_current, target);
				}

				if ( $trigger_current.data('event-onclose') !== undefined && !_.first_load ) {
					try {
						// Note: Eval is executed even if used in a conditional statement
						eval( $trigger_current.data('event-onclose') );
					}
					catch(error) {
						console.warn( 'Dishide event onClose:', error );
					}
				}
			}
        }

	};
	
	Dishide.prototype.open = function($tab_active) {
		const _ = this;
		
		if( _.$app.data('dishide-is_initialized') !== true ) {
			return;
		}

		_.$tab_active = ( $tab_active === undefined )? _.$app : $tab_active;
		_.tab_active();
	};

	Dishide.prototype.close = function() {
		const _ = this;

		if( _.$app.data('dishide-is_initialized') !== true ) {
			return;
		}

		_.$tab_active = null;
		_.tab_active();
	};

    // if lightbox mode is on we trapped the focus inside of it.
    Dishide.prototype.lightbox_loop = function(target) {

        target.siblings().each(function () {
            var $object = $(this);
            if ($object.attr('aria-hidden') == undefined) {
                $object.attr('aria-hidden', true);
            } else if ($object.attr('aria-hidden') == true) {
                $object.attr({
                    'data-aria-was': $object.attr('aria-hidden')
                });
            }
        });

        // Keydown instead of up to be able to prevent tabbing outside of the modal when there is only one element
        target.on(`keydown.dishide-${_.app_instance_index}`, function (event) {

            const items_focusable = focusable_elements(target);
            _.items_focusable_nb = items_focusable.length;

            // get the index of the currently focused item
            const item_focused_index = items_focusable.index(jQuery(':focus'));

            // Reverse navigation
            if (event.shiftKey && event.which == 9 || event.which == 38) {
                if (item_focused_index === 0) {
                    if( _.items_focusable_nb !== 1 ) {
                        items_focusable.get(_.items_focusable_nb - 1).focus();
                    } else {
                        items_focusable.get(0).focus();
                    }
                    event.preventDefault();
                }
            }
            // Forward navigation
            else if (event.which == 9 || event.which == 40) {
                if (item_focused_index === _.items_focusable_nb - 1) {
                    items_focusable.get(0).focus();
                    event.preventDefault();
                }
            }
        });
    };

    Dishide.prototype.destroy = function(action) {
        // tabs_enabled : Destroy used within the plugin
        // _.destroy : Destroy used when called by user .dishide('destroy')
        const _ = this;

        if( _.tabs_enabled === true ){
            _.tabs_enabled = false;

            if (_.has_follower === true) {
                _.$follower.remove();
            }
            _.trigger.each(function (index) {
                var $trigger_current = $(this);
                var $trigger_current_display;
                var target;
                const regexInstanceNameChar = /#|\./g;
                const regexInstanceNameSpace = / /g;

                // If the target is a group, find the active target with the index of _.trigger
                if( _.$group_targets !== null ) {
                    $trigger_current_display = _.$group_targets.eq( index );
                } else {
                    $trigger_current_display = ($trigger_current.data('display-tab') !== undefined) ? $trigger_current.data('display-tab') : null;
                }
                if ($trigger_current_display !== null) {
                    // If the target is a group
                    if( _.$group_targets !== null ) {
                        target = ( _.instance_container !== null ) ? _.instance_container.find($trigger_current_display) : $trigger_current_display;

                        // Will be added on the HTML and Modal Overlay
                        _.module_class_active = `dishide-instance-${_.$app.data( 'display-bygroup' ).replace( regexInstanceNameChar, '' ).replace( regexInstanceNameSpace, '-' )}-${_.class_active}`;
                    }
                    // If the target is a specific tab
                    else {
                        target = (_.instance_container !== null ) ? $(_.instance_container.find($trigger_current_display)) : $($trigger_current_display);

                        // Will be added on the HTML and Modal Overlay
                        _.module_class_active = `dishide-instance-${$trigger_current_display.replace( regexInstanceNameChar, '' ).replace( regexInstanceNameSpace, '-' )}-${_.class_active}`;
                    }

                    target.removeClass(`dishide-target--inactive dishide-target--active dishide-is_initialized dishide-is_${_.mode}`);
                    if( action !== 'disabled' ) {
                        _.trigger.off('click.dishide keyup.dishide').removeClass( `${_.class_active} dishide-trigger-is_initialized` );
                        $('html').removeClass( _.module_class_active );
                        _.$app.data({
                            'dishide-is_initialized': false,
                            'dishide-is_animating': ''
                        });
                    }

                    if( _.mode_overlay ) {
                        _.$app.data('dishide-overlay', null);
                        _.remove_overlay();
                    }

                    _.$app.data('firstLoad', false);
                    _.first_load = true;
                }
            });
        }
    };

    // Destroy or initialize a dishide instance
    Dishide.prototype.init_destroy = function() {
		const _ = this;

        if (_.except_breakpoint === Revealizr.currentViewportSize) {
            _.destroy('disabled');
        }
        else if (_.only_breakpoint !== Revealizr.currentViewportSize && _.only_breakpoint !== null && _.first_load === false && _.tabs_enabled === true && _.only_device !== Revealizr.deviceType) {
            _.destroy('disabled');
        }
        else if (_.only_breakpoint === Revealizr.currentViewportSize && _.tabs_enabled === false && _.only_device === Revealizr.deviceType) {
            _.init();
        }
        else if (_.only_breakpoint === Revealizr.currentViewportSize && _.tabs_enabled === false) {
            _.init();
        }
        else if (_.tabs_enabled === false && _.only_device === Revealizr.deviceType) {
            _.init();
        } else if (_.only_breakpoint === null && _.only_device === null && _.tabs_enabled === false ) {
            _.init();
        }
	};
	
	// Resize and create the follower
	Dishide.prototype.follower = function() {
		const _ = this;

		const tab_width = _.$tab_active.outerWidth();
		const tabs_borderWidth = parseInt(_.trigger_wrapper.css('border-left-width'));
		const tab_offsetLeft = (_.$tab_active.offset().left - _.trigger_wrapper.offset().left) - tabs_borderWidth;
		// if data-has="follower" was set to true then add the follower
		if ( _.first_load ) {
			var follower_class = 'dishide-follower';

			var follower_html = '<span class="' + follower_class + '" style="left: 0;"></span>';
			_.trigger_wrapper.append( follower_html );
			_.$follower = _.trigger_wrapper.find( '.' + follower_class );
		}

		// Update the position and the width of the follower equal to the left/width value of the active tab
		_.$follower.css({
			transform: 'translateX(' + tab_offsetLeft + 'px)',
			width: tab_width
		});
	};

    Dishide.prototype.is_one_active_item = function() {
		const _ = this;
			
        if( !_.trigger.hasClass(_.class_active) ) {
            // Remove the overlay when mode_lightbox or mode_overlay
            _.remove_overlay();
        }
    };

    Dishide.prototype.remove_overlay = function() {
        const _ = this;

        if( _.mode_overlay ) {
            $(`.dishide-overlay.${_.overlay_class_active}`).remove();
            _.$app.data('dishide-overlay', null);
        }
        // Removes overlay Active CLASS on the HTML if no other instance uses it
        if( _.mode_overlay && $( '.dishide-overlay' ).length === 0 ) {
            $('html').removeClass( 'dishide-overlay-is_active' );
            // make sure this class is remove when there's no overlay
            $('body').removeClass('modal--mobile-fixed-scroll');
        }
    };

    Dishide.prototype.group_active = function() {
        const _ = this;
        if ( _.$group_targets !== null && _.$app.find( '.' + _.class_active ).length === 1 ) {
            _.group_active_state = true;
        } else {
            _.group_active_state = false;
        }
    };

    // Used for mode lightbox | menu_slide
    const focusable_elements = function(target) {
        // List all focusable elements
        var elements_focusable_string = "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex]";
        return target.find(elements_focusable_string).filter(':visible');
    };

    // When the target is active focus on the first focusable element unless specified otherwise.
    // Enabled by lightbox mode or manually
    Dishide.prototype.setFocusFirstItem = function(target, initial_focus_index) {
		const _ = this;
		
        let items_focusable = focusable_elements(target);
        // Find how many items are focusable
        _.items_focusable_nb = items_focusable.length;
        let $tabbable_elem_first = items_focusable.eq(initial_focus_index);

        $tabbable_elem_first.focus();
    };

    $.fn.dishide = function() {

        var _ = this,
            opt = arguments[0],
            args = Array.prototype.slice.call(arguments, 1),
            thisLength = _.length,
            i,
            ret;
        for (i = 0; i < thisLength; i++) {
            if ( ( typeof opt == 'object' || typeof opt == 'undefined' ) && args.length === 0 ) {
                _[i].dishide = new Dishide(_[i], opt);
            }
            else if( ( typeof opt == 'object' || typeof opt == 'undefined' ) ) {
				if( $(_[i]).data('dishide-is_initialized') !== true ) {
					_[i].dishide = new Dishide(_[i], opt);
				}
				ret = _[i].dishide[arguments[1]].apply(_[i].dishide, Array.prototype.slice.call(arguments, 2));
			} else {
				if( $(_[i]).data('dishide-is_initialized') !== true ) {
					_[i].dishide = new Dishide(_[i], opt);
					ret = _[i].dishide[arguments[0]].apply(_[i].dishide, Array.prototype.slice.call(arguments, 1));
				}else {
					ret = _[i].dishide[opt].apply(_[i].dishide, args);
				}
				
            }
            if (typeof ret != 'undefined') return ret;
        }

        return _;
    };

}));